<template>
  <v-dialog v-model="opened" persistent fullscreen>
    <v-container fluid class="d-flex justify-center primary" style="min-height: 100%;">
      <v-col cols="10" class="py-0">
        <v-btn v-if="contentType.expose && false" class="mt-1" light @click="createNew">
          <v-icon>note_add</v-icon>
        </v-btn>

        <v-row justify="center">
          <v-col cols="10" class="py-0">
            <SearchPicker :content-type="contentType" :on-click-item="actionOnInfoTable" :field="field" />
          </v-col>

          <v-btn icon fixed top right class="mt-3 mr-5" @click="toogle">
            <v-icon color="white" size="35">
              close
            </v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-container>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue';

import SearchPicker from './SearchPicker.vue';

// eslint-disable-next-line no-undef
const props = defineProps({
  field: { type: Object, default: () => { } },
  actionOnInfoTable: { type: Function, default: () => { } },
  contentType: { type: Object, default: () => { } }
});

const opened = ref(false);

const toogle = () => {
  opened.value = !opened.value;
};

// eslint-disable-next-line no-undef
defineExpose({ toogle });

</script>

<style lang="scss" scoped>

</style>
